import deviceTypeController from "@/services/deviceTypeService";
import parameterController from "@/services/parameterService";
import Swal from "sweetalert2";

export default {
  name: "DeviceTypeView",

  data() {
    return {
      items: [],
      total: 0,
      loading: false,

      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      totalPages: 1,

      filters: {
        search: "",
        status: "",
        category: "", // ← ditambahkan
      },

      categoryList: [], // ← list Hardware/Software dari m004_parameter

      showModal: false,
      isEdit: false,
      saving: false,
      formError: "",

      form: {
        device_type_id: null,
        device_type_name: "",
        device_category: null,
        status: 1,
      },

      errors: {
        device_type_name: "",
        device_category: "",
      },

      toast: {
        show: false,
        message: "",
        type: "success",
      },
      toastTimer: null,
    };
  },

  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },

  mounted() {
    this.loadCategoryList();
    this.getData();
  },

  methods: {
    async loadCategoryList() {
      try {
        const result = await parameterController.getAll({ param_id: 7 });
        this.categoryList = result?.data?.data ?? result?.data ?? [];
      } catch (error) {
        console.error(error);
        this.categoryList = [];
      }
    },

    async getData() {
      this.loading = true;

      const result = await deviceTypeController.getAll({});
      let filtered = result?.data?.data ?? result?.data ?? [];

      if (this.filters.search) {
        const q = this.filters.search.toLowerCase();
        filtered = filtered.filter((item) =>
          item.device_type_name?.toLowerCase().includes(q),
        );
      }

      if (this.filters.status !== "") {
        const s = parseInt(this.filters.status);
        filtered = filtered.filter((item) =>
          item.status !== undefined ? item.status == s : true,
        );
      }
      if (this.filters.category !== "" && this.filters.category !== null) {
        const c = parseInt(this.filters.category);
        filtered = filtered.filter((item) =>
          item.device_category != null ? item.device_category == c : false,
        );
      }

      this.total = filtered.length;
      this.totalPages = Math.ceil(this.total / this.perPage) || 1;

      if (this.page > this.totalPages) this.page = this.totalPages;

      const start = (this.page - 1) * this.perPage;
      this.items = filtered.slice(start, start + this.perPage);

      this.loading = false;
    },

    changePerPage() {
      this.page = 1;
      this.getData();
    },

    changePage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.page = p;
      this.getData();
    },

    openModal() {
      this.isEdit = false;
      this.formError = "";
      this.clearErrors();
      this.form = {
        device_type_id: null,
        device_type_name: "",
        device_category: null,
        status: 1,
      };
      this.showModal = true;
    },

    openEdit(item) {
      this.isEdit = true;
      this.formError = "";
      this.clearErrors();
      this.form = {
        device_type_id: item.device_type_id,
        device_type_name: item.device_type_name,
        device_category: item.device_category ?? null,
        status: item.status ?? 1,
      };
      this.showModal = true;
    },

    closeModal() {
      if (this.saving) return;
      this.showModal = false;
      this.formError = "";
      this.clearErrors();
    },

    validateForm() {
      this.clearErrors();
      let valid = true;

      if (!this.form.device_type_name?.trim()) {
        this.errors.device_type_name =
          "Nama tipe perangkat tidak boleh kosong.";
        valid = false;
      } else if (this.form.device_type_name.trim().length > 100) {
        this.errors.device_type_name =
          "Nama tipe perangkat maksimal 100 karakter.";
        valid = false;
      }

      if (!this.form.device_category) {
        this.errors.device_category = "Kategori wajib dipilih.";
        valid = false;
      }

      return valid;
    },

    clearErrors() {
      this.errors = {
        device_type_name: "",
        device_category: "",
      };
    },

    async saveForm() {
      if (!this.validateForm()) return;

      this.saving = true;
      try {
        this.formError = "";

        const payload = {
          device_type_name: this.form.device_type_name.trim(),
          device_category: this.form.device_category,
          status: this.form.status,
        };

        let result;

        if (this.isEdit) {
          result = await deviceTypeController.update(
            this.form.device_type_id,
            payload,
          );
        } else {
          result = await deviceTypeController.create(payload);
        }
        if (result.success) {
          this.saving = false;
          this.closeModal();
          this.page = 1;
          this.getData();
          this.showToast(
            this.isEdit
              ? "Tipe perangkat berhasil diperbarui."
              : "Tipe perangkat berhasil ditambahkan.",
            "success",
          );
        } else {
          this.formError = result.message || "Gagal menyimpan data.";
        }
      } catch (err) {
        console.error(err);
        this.formError =
          err.response?.data?.message || err.message || "Gagal menyimpan data.";
      } finally {
        this.saving = false;
      }
    },

    async toggleStatus(item) {
      const newStatus = item.status == 1 ? 0 : 1;
      const action = newStatus === 1 ? "mengaktifkan" : "menonaktifkan";
      const label = newStatus === 1 ? "diaktifkan" : "dinonaktifkan";

      const confirm = await Swal.fire({
        title: "Konfirmasi",
        text: `Yakin ingin ${action} tipe perangkat ini?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        confirmButtonColor: "#198754",
      });

      if (!confirm.isConfirmed) return;

      const result = await deviceTypeController.updateStatus(
        item.device_type_id,
        newStatus,
      );

      if (result.success) {
        this.getData();
        this.showToast(`Tipe perangkat berhasil ${label}.`, "success");
      } else {
        this.showToast(result.message || "Gagal mengubah status.", "danger");
      }
    },

    showToast(message, type = "success") {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toast = { show: true, message, type };
      this.toastTimer = setTimeout(() => {
        this.toast.show = false;
      }, 3000);
    },
  },

  beforeUnmount() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
};
